module.exports = __webpack_public_path__ + "static/media/ic-been-here.0ec804e3.svg";